import { render, staticRenderFns } from "./ContentBlockHeading.vue?vue&type=template&id=02af29ab&"
import script from "./ContentBlockHeading.vue?vue&type=script&lang=js&"
export * from "./ContentBlockHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports